import styled from "styled-components";

// Dependency-light on purpose: this page is served to anonymous recipients
// (no auth, often on a phone from an email link), so it avoids antd/MUI and
// sticks to styled-components + phosphor icons, both already app-wide deps.

export const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 64px;
  font-family: "Manrope", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;

  img {
    height: 28px;
  }
`;

export const FirmName = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #1b2028;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 640px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
  padding: 24px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const FolderTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: #1b2028;
  margin: 0 0 4px 0;
  word-break: break-word;
`;

export const ExpiryNotice = styled.p`
  font-size: 13px;
  color: #5a6c87;
  margin: 0 0 16px 0;
`;

export const TruncatedNotice = styled.p`
  font-size: 13px;
  color: #9a6a00;
  background: #fff6e5;
  border: 1px solid #ffe6a8;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 0 0 16px 0;
`;

export const ZipButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #0c53bb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FolderNodeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-weight: 600;
  color: #1b2028;
  cursor: pointer;
`;

export const FolderChildren = styled.div`
  margin-left: 20px;
  border-left: 1px solid #e6eaf0;
  padding-left: 12px;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
`;

export const FileName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1b2028;
  font-size: 14px;
`;

export const FileMeta = styled.span`
  color: #8896a8;
  font-size: 12px;
  white-space: nowrap;
`;

export const DownloadButton = styled.button`
  border: none;
  background: transparent;
  color: #0c53bb;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 4px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyNotice = styled.p`
  color: #8896a8;
  font-size: 14px;
  margin: 8px 0 0 0;
`;

export const PasswordForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

export const PasswordInput = styled.input`
  border: 1px solid ${(p) => (p.error ? "#e33d3d" : "#d7dde5")};
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
`;

export const SubmitButton = styled.button`
  background: #0c53bb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  color: #e33d3d;
  font-size: 13px;
  margin: 0;
`;

export const StateMessage = styled.div`
  text-align: center;
  color: #5a6c87;
  font-size: 15px;
  padding: 32px 0;
`;

export const Spinner = styled.div`
  border: 3px solid #e6eaf0;
  border-top-color: #0c53bb;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  margin: 0 auto 12px;
  animation: shared-folder-spin 0.8s linear infinite;

  @keyframes shared-folder-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
